export default (leadData) => {
    const tags = leadData.tags.reduce((arr,tagObj) => {
        return arr.concat(tagObj.name)
    }, []);

    function getStep (tagsArr) {
        if (tagsArr.includes("Accepted DBA")) return 6;
        else if (tagsArr.includes("High Court")) return window.location.replace(process.env.REACT_APP_HIGH_COURT_URL);
        else if (tagsArr.includes("Completed Initial Registration TRO")) return window.location.replace(process.env.REACT_APP_COMPL_INIT_REG_TRO_URL);
        else return 5;
    }

    return {
        step: getStep(tags)
    };
};
